module.exports = __webpack_public_path__ + "static/img/Reuben-Garrick.8e69143.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reuben-Garrick.jpg
// module id = pb4V
// module chunks = 0